import { FieldValues, useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { lt } from '@mews/framework';
import { Stack, Typography } from '@optimus-web/core';
import { useEnterprisesProductContext } from '../../../../context/EnterprisesProductContext';
import { ConfigureProductFormStep, getBasePriceFieldName, PricingFieldNames } from '../../formEnums';
import { PriceInput } from '../../common/PriceInput';

export const PricingSinglePropertyForm = () => {
    const {
        state: { enterprises },
    } = useEnterprisesProductContext();

    const { defaultCurrencyCode, id } = enterprises[0] || {};

    const { getFieldState, setValue } = useFormContext<FieldValues>();
    const { isDirty } = getFieldState(getBasePriceFieldName(id) || '');

    useEffect(() => {
        if (defaultCurrencyCode) {
            setValue(
                `${ConfigureProductFormStep.Pricing}.${id}.${PricingFieldNames.CurrencyCode}`,
                defaultCurrencyCode
            );
        }
    }, [defaultCurrencyCode, id, setValue]);

    return (
        <Stack vertical spacing="300">
            <Stack vertical spacing="200">
                <Typography textStyle="titleSmallStrong" as="div">
                    {lt('ConfigureProductSubHeadingPrice')}
                </Typography>
                <Typography textStyle="bodyMedium" variant="secondary" as="div">
                    {lt('ConfigureProductPriceBody')}
                </Typography>
            </Stack>
            <PriceInput
                defaultCurrencyCode={defaultCurrencyCode}
                isDirty={isDirty}
                name={getBasePriceFieldName(id)}
                label={lt('GeneralPriceExcludingTax')}
                size="small"
            />
        </Stack>
    );
};
